import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AProposPage from "@/pages/AProposPage";
import ExpertisePage from "@/pages/ExpertisePage";
import EstimationPage from "@/pages/EstimationPage";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";

export default function App() {
    return (
        <LanguageProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/expertise" element={<ExpertisePage />} />
                        <Route path="/estimation" element={<EstimationPage />} />
                        <Route path="/a-propos" element={<AProposPage />} />
                    </Routes>
                </BrowserRouter>
                <Toaster />
            </div>
        </LanguageProvider>
    );
}
